import React from 'react';
import {Navigate, Route, Routes, useParams} from "react-router-dom";
import {Box} from "@mui/material";
import {SideNavigation} from "@dreebit-registry/vsm-microservice-components";
import {SideNavItems} from "@dreebit-registry/vsm-microservice-components/dist/types";
import AttributeInformation from "../../../components/AttributeInformation";
import AttributeOptionValueList from "../../../components/AttributeOptionValueList";
import Breadcrumbs, {breadcrumbConfig} from "../../../components/Breadcrumbs";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import {useTranslation} from "react-i18next";
import {useQuery} from "@apollo/client";
import {InstalledBaseNodeAttribute} from "../../../graphql/queries/installedBaseNodeAttribute";
import {InstalledBaseNodeAttributeQuery, PropertyInputType} from "../../../codegen/graphql";


const AttributeDetailsScreen = () => {
    const { attributeId } = useParams();
    const {t} = useTranslation();
    const breadcrumbs = useBreadcrumbs(breadcrumbConfig(t));

    const { data } = useQuery<InstalledBaseNodeAttributeQuery>(InstalledBaseNodeAttribute, {
        variables: { id: attributeId },
        skip: !attributeId,
    });

    if (!attributeId) return null;

    const inputType = data?.installedBaseNodePropertyDefinition?.inputType;
    const showOptionValues = inputType === PropertyInputType.SELECT || inputType === PropertyInputType.MULTISELECT;

    const navItems: SideNavItems[] = [
        { label: 'Information', to: `/configurations/attributes/${attributeId}/information`},
        ...(showOptionValues ? [{ label: 'Option values', to: `/configurations/attributes/${attributeId}/optionValues`}] : []),
    ];

    return (
        <div className={"flex-row"} style={{flexGrow: 1}}>
            <Box sx={{
                width: 320,
                borderRight: "1px solid #ccc",
                padding: "0 12px 0 0",
            }}>
                <SideNavigation navItems={navItems} />
            </Box>
            <Box sx={{flex: 1, padding: "12px 24px", width: "100%"}}>
                <Breadcrumbs breadcrumbs={breadcrumbs} sx={{ mb: 2 }} />
                <Routes>
                    <Route path="information" element={<AttributeInformation attributeId={attributeId}/>}/>
                    {showOptionValues && <Route path="optionValues" element={<AttributeOptionValueList attributeId={attributeId}/>}/>}
                    <Route path="*" element={<Navigate to={`/configurations/attributes/${attributeId}/information`} replace />} />
                </Routes>
            </Box>
        </div>
    );
};

export default AttributeDetailsScreen;
